import { render, staticRenderFns } from "./AddToRelationModal.vue?vue&type=template&id=0b0fb670&scoped=true&"
import script from "./AddToRelationModal.vue?vue&type=script&lang=js&"
export * from "./AddToRelationModal.vue?vue&type=script&lang=js&"
import style0 from "./AddToRelationModal.vue?vue&type=style&index=0&id=0b0fb670&scoped=true&lang=css&"
import style1 from "./AddToRelationModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0fb670",
  null
  
)

export default component.exports